// extracted by mini-css-extract-plugin
module.exports = {"chevron":"Chevron_chevron__3SLOY","down":"Chevron_down__1H1Kt","up":"Chevron_up__3D-Cm","right":"Chevron_right__3jwvg","left":"Chevron_left__2XXry"};